import { create } from 'zustand';

const EMPTY_FORM = {
  name: '',
  surname: '',
  emailAddress: '',
  phone: { countryCode: '+90', number: '' },
  role: 'customer',
  status: 'active',
};

const useCustomersStore = create((set) => ({
  // ── Arama ───────────────────────────────────────────────────────────────────
  searchTerm: '',
  setSearchTerm: (term) => set({ searchTerm: term, currentPage: 1 }),

  // ── Pagination ───────────────────────────────────────────────────────────────
  currentPage: 1,
  itemsPerPage: 10,
  setCurrentPage: (page) => set({ currentPage: page }),
  setItemsPerPage: (n) => set({ itemsPerPage: n, currentPage: 1 }),

  // ── Expand state ─────────────────────────────────────────────────────────────
  expandedCustomerId: null,
  toggleExpand: (customerId) =>
    set((s) => ({ expandedCustomerId: s.expandedCustomerId === customerId ? null : customerId })),

  // ── Bill search + pagination (per customer) ──────────────────────────────────
  billSearchTerms: {},  // { [customerId]: string }
  billCurrentPages: {}, // { [customerId]: number }
  setBillSearchTerm: (customerId, term) =>
    set((s) => ({
      billSearchTerms: { ...s.billSearchTerms, [customerId]: term },
      billCurrentPages: { ...s.billCurrentPages, [customerId]: 1 },
    })),
  setBillCurrentPage: (customerId, page) =>
    set((s) => ({ billCurrentPages: { ...s.billCurrentPages, [customerId]: page } })),

  // ── Modal ────────────────────────────────────────────────────────────────────
  isModalOpen: false,
  isEditing: false,
  selectedCustomerId: null,
  formData: { ...EMPTY_FORM },

  openModal: (customer = null) =>
    set(customer
      ? {
          isModalOpen: true,
          isEditing: true,
          selectedCustomerId: customer.id,
          formData: {
            ...customer,
            phone: customer.phone || { countryCode: '+90', number: '' },
          },
        }
      : {
          isModalOpen: true,
          isEditing: false,
          selectedCustomerId: null,
          formData: { ...EMPTY_FORM },
        }),

  closeModal: () => set({ isModalOpen: false }),

  updateFormField: (key, value) =>
    set((s) => ({ formData: { ...s.formData, [key]: value } })),

  // ── Backfill ─────────────────────────────────────────────────────────────────
  backfillLoading: null,
  setBackfillLoading: (id) => set({ backfillLoading: id }),
}));

export default useCustomersStore;
